import * as React from "react";
import { QuizData, TourData, question } from "../../../../Types";
import { QuizAddIcon } from "../../../Icons/left-side-bar-icons";
import { useViewerPopupStore } from "../../../../state management/zustand/viewer-stores";
import {
  useEscapeRoomDataStore,
  useMockEscapeRoomStore,
} from "../../escape-room/zustand";

function ViewerQuiz(props: {
  quiz: any;
  tourData: TourData;
  zoom: number;
  quizData: QuizData;
}) {
  const { setOpen } = useViewerPopupStore();

  const { started, ended, type: escapeRoomType } = useEscapeRoomDataStore();
  const escapeRoomIsRunning = started && !ended;

  const currentQ: question | undefined = React.useMemo(() => {
    return props.quizData.data.find(
      (one) => one.questionId === props.quiz.target
    );
  }, [props.quiz, props.quizData.data]);

  const shouldOpen = React.useMemo(() => {
    if (props.tourData.escapeRoomData && escapeRoomIsRunning) {
      return true;
    } else if (!props.tourData.escapeRoomData) {
      return true;
    }
  }, [escapeRoomIsRunning, props.tourData.escapeRoomData]);

  const { answeredCorrectly, answeredWrongly } = useMockEscapeRoomStore();

  const hasBeenAnswered = React.useMemo(() => {
    if (currentQ?.questionId) {
      if (answeredCorrectly.includes(currentQ?.questionId)) return true;
      else if (answeredWrongly.includes(currentQ?.questionId)) return false;
    }
  }, [answeredCorrectly, answeredWrongly, currentQ?.questionId]);

  return (
    <div
      onClick={() => {
        if (shouldOpen) {
          setOpen(props.quiz.target);
        }
      }}
      style={{ cursor: "pointer" }}
      // tooltip-text={
      //   currentQ ? currentQ.questionText : "Testo della domanda non caricato"
      // }
      // className="viewer-exp-icon-quiz"
    >
      <div className="quiz-icon-overlay">
        {/* {hasBeenAnswered === true
          ? tick
          : hasBeenAnswered === false
          ? cross
          : null} */}
      </div>

      <QuizAddIcon
        width="4rem"
        height="4rem"
        fill="white"
        stroke="#222"
        strokeWidth="20px"
        style={{
          zIndex: 1,
          opacity: ((props.zoom - 15) * 100) / 76 <= 30 ? 0.3 : 1, // : hasBeenAnswered !== undefined
          // ? 0.3
          // : 1,
        }}
      />
    </div>
  );
}

export default ViewerQuiz;

const tick = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="#fff"
    stroke="#222"
    height={"4rem"}
    width={"4rem"}
    strokeWidth={20}
    className="correct"
  >
    <path d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z" />
  </svg>
);

const cross = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    height={"4rem"}
    width={"4rem"}
    strokeWidth={30}
    stroke="#222"
    fill="#e8eaed"
    className="wrong"
  >
    <path d="m336-280-56-56 144-144-144-143 56-56 144 144 143-144 56 56-144 143 144 144-56 56-143-144-144 144Z" />
  </svg>
);
